module.exports = __webpack_public_path__ + "static/media/passportEnrollment.bfaa9e52.svg";